import type { LandingStatus } from "../../types/domain";

export interface LandingStatusMeta {
  label: string;
  color: string;
  bg: string;
  dotColor: string;
}

export const LANDING_STATUS_META: Record<LandingStatus, LandingStatusMeta> = {
  draft: { label: "Черновик", color: "#7A849B", bg: "#F1F3F8", dotColor: "#A0A8BD" },
  ready: { label: "Готов", color: "#0F766E", bg: "#CCFBF1", dotColor: "#14B8A6" },
  published: { label: "Опубликован", color: "#3730A3", bg: "#E0E7FF", dotColor: "#6366F1" },
};
